var styleClasses = {
  "badge": "badge__8iY5F",
  "pill-content": "pill-content__P-w88",
  "xsmall": "xsmall__5QUV6",
  "small": "small__F4NmH",
  "medium": "medium__leKOP",
  "large": "large__4-hxE",
  "xlarge": "xlarge__bTSYZ"
};
export { styleClasses as default };